class ModuleCountDownFlip {
    constructor() {
        this.countdownFlipHanle();
        this.countdownFlipHanleMobile();
    }

    countdownFlipHanle = function(){
        const countdowns = document.querySelectorAll('.countdown-flip');
        countdowns.forEach((countdown) => {
            if (countdown.classList.contains('countdown-initialized')){
                return;
            }
            countdown.classList.add('countdown-initialized');
            
            const valueTime = countdown.dataset.timedown;
            const countToDate = new Date(valueTime);

            const currentDateInit = new Date()
            const timeBetweenDatesInit = Math.ceil((countToDate - currentDateInit) / 1000)
            if (timeBetweenDatesInit < 0){
                return;
            }
            flipAllCardsInit(countdown, timeBetweenDatesInit)
            countdown.style.opacity = "";
        
            let previousTimeBetweenDates
            let intervalTimeout;
            intervalTimeout = setInterval(() => {
                const currentDate = new Date()
                const timeBetweenDates = Math.ceil((countToDate - currentDate) / 1000)
                if (timeBetweenDates < 0){
                    clearInterval(intervalTimeout);
                }
                flipAllCards(countdown, timeBetweenDates)
    
                previousTimeBetweenDates = timeBetweenDates
            }, 250)

        })

        function flipAllCards(target, time) {
            const seconds = time % 60
            const minutes = Math.floor(time / 60) % 60
            const hours = Math.floor(time / 3600) % 24
            const days = Math.floor(time / 3600 / 24 )

            if (target.querySelector("[data-days-tens]") && target.querySelector("[data-days-ones]")){
                flip(target.querySelector("[data-days-tens]"), Math.floor(days / 10))
                flip(target.querySelector("[data-days-ones]"), days % 10)
            }
            if (target.querySelector("[data-hours-tens]") && target.querySelector("[data-hours-ones]")){
                flip(target.querySelector("[data-hours-tens]"), Math.floor(hours / 10))
                flip(target.querySelector("[data-hours-ones]"), hours % 10)
            }
            if (target.querySelector("[data-minutes-tens]") && target.querySelector("[data-minutes-ones]")){
                flip(target.querySelector("[data-minutes-tens]"), Math.floor(minutes / 10))
                flip(target.querySelector("[data-minutes-ones]"), minutes % 10)
            }
            if (target.querySelector("[data-seconds-tens]") && target.querySelector("[data-seconds-ones]")){
                flip(target.querySelector("[data-seconds-tens]"), Math.floor(seconds / 10))
                flip(target.querySelector("[data-seconds-ones]"), seconds % 10)
            }
        }

        function flipAllCardsInit(target, time) {
            const seconds = time % 60
            const minutes = Math.floor(time / 60) % 60
            const hours = Math.floor(time / 3600) % 24
            const days = Math.floor(time / 3600 / 24 )

            if (target.querySelector("[data-days-tens]") && target.querySelector("[data-days-ones]")){
                flipInit(target.querySelector("[data-days-tens]"), Math.floor(days / 10))
                flipInit(target.querySelector("[data-days-ones]"), days % 10)
            }
            if (target.querySelector("[data-hours-tens]") && target.querySelector("[data-hours-ones]")){
                flipInit(target.querySelector("[data-hours-tens]"), Math.floor(hours / 10))
                flipInit(target.querySelector("[data-hours-ones]"), hours % 10)
            }
            if (target.querySelector("[data-minutes-tens]") && target.querySelector("[data-minutes-ones]")){
                flipInit(target.querySelector("[data-minutes-tens]"), Math.floor(minutes / 10))
                flipInit(target.querySelector("[data-minutes-ones]"), minutes % 10)
            }
            if (target.querySelector("[data-seconds-tens]") && target.querySelector("[data-seconds-ones]")){
                flipInit(target.querySelector("[data-seconds-tens]"), Math.floor(seconds / 10))
                flipInit(target.querySelector("[data-seconds-ones]"), seconds % 10)
            }
        }

        function flipInit(flipCard, newNumber) {
            const topHalf = flipCard.querySelector(".top")
            const startNumber = parseInt(topHalf.textContent)
            if (newNumber === startNumber) return


            const bottomHalf = flipCard.querySelector(".bottom")
            topHalf.innerHTML = `<span>${newNumber}</span>`
            bottomHalf.innerHTML = `<span>${newNumber}</span>`
            
        }

        function flip(flipCard, newNumber) {
            const topHalf = flipCard.querySelector(".top")
            const startNumber = parseInt(topHalf.textContent)
            if (newNumber === startNumber) return

            const bottomHalf = flipCard.querySelector(".bottom")
            const topFlip = document.createElement("div")
            topFlip.classList.add("top-flip")
            const bottomFlip = document.createElement("div")
            bottomFlip.classList.add("bottom-flip")

            bottomHalf.innerHTML = `<span>${startNumber}</span>`
            topFlip.innerHTML = `<span>${startNumber}</span>`
            bottomFlip.innerHTML = `<span>${newNumber}</span>`

            topFlip.addEventListener("animationstart", e => {
                topHalf.innerHTML = `<span>${newNumber}</span>`
            })
            topFlip.addEventListener("animationend", e => {
                topFlip.remove()
            })
            bottomFlip.addEventListener("animationend", e => {
                bottomHalf.innerHTML = `<span>${newNumber}</span>`
                bottomFlip.remove()
            })
            flipCard.append(topFlip, bottomFlip)
        }
    }
    countdownFlipHanleMobile = function(){
        const countdowns = document.querySelectorAll('.countdown-flip-mobile');
        countdowns.forEach((countdown) => {
            if (countdown.classList.contains('countdown-initialized')){
                return;
            }
            countdown.classList.add('countdown-initialized');
            
            const valueTime = countdown.dataset.timedown;
            const countToDate = new Date(valueTime);

            const currentDateInit = new Date()
            const timeBetweenDatesInit = Math.ceil((countToDate - currentDateInit) / 1000)
            if (timeBetweenDatesInit < 0){
                return;
            }
            flipAllCardsInit(countdown, timeBetweenDatesInit)
            countdown.style.opacity = "";
        
            let previousTimeBetweenDates
            let intervalTimeout;
            intervalTimeout = setInterval(() => {
                const currentDate = new Date()
                const timeBetweenDates = Math.ceil((countToDate - currentDate) / 1000)
                if (timeBetweenDates < 0){
                    clearInterval(intervalTimeout);
                }
                flipAllCards(countdown, timeBetweenDates)
    
                previousTimeBetweenDates = timeBetweenDates
            }, 250)

        })

        function flipAllCards(target, time) {
            const seconds = time % 60
            const minutes = Math.floor(time / 60) % 60
            const hours = Math.floor(time / 3600) % 24
            const days = Math.floor(time / 3600 / 24 )

            if (target.querySelector("[data-days]") && target.querySelector("[data-days]")){
                flip(target.querySelector("[data-days]"), Math.floor(days))
            }
            if (target.querySelector("[data-hours]") && target.querySelector("[data-hours]")){
                flip(target.querySelector("[data-hours]"), Math.floor(hours))
            }
            if (target.querySelector("[data-minutes]") && target.querySelector("[data-minutes]")){
                flip(target.querySelector("[data-minutes]"), Math.floor(minutes))
            }
            if (target.querySelector("[data-seconds]") && target.querySelector("[data-seconds]")){
                flip(target.querySelector("[data-seconds]"), Math.floor(seconds))
            }
        }

        function flipAllCardsInit(target, time) {
            const seconds = time % 60
            const minutes = Math.floor(time / 60) % 60
            const hours = Math.floor(time / 3600) % 24
            const days = Math.floor(time / 3600 / 24 )

            if (target.querySelector("[data-days]") && target.querySelector("[data-days]")){
                flipInit(target.querySelector("[data-days]"), Math.floor(days / 10))
            }
            if (target.querySelector("[data-hours]") && target.querySelector("[data-hours]")){
                flipInit(target.querySelector("[data-hours]"), Math.floor(hours / 10))
            }
            if (target.querySelector("[data-minutes]") && target.querySelector("[data-minutes]")){
                flipInit(target.querySelector("[data-minutes]"), Math.floor(minutes / 10))
            }
            if (target.querySelector("[data-seconds]") && target.querySelector("[data-seconds]")){
                flipInit(target.querySelector("[data-seconds]"), Math.floor(seconds / 10))
            }
        }

        function flipInit(flipCard, newNumber) {
            const topHalf = flipCard.querySelector(".top")
            const startNumber = parseInt(topHalf.textContent)
            if (newNumber === startNumber) return


            const bottomHalf = flipCard.querySelector(".bottom")
            topHalf.innerHTML = `<span>${newNumber > 9 ? newNumber : `0${newNumber}`}</span>`
            bottomHalf.innerHTML = `<span>${newNumber > 9 ? newNumber : `0${newNumber}`}</span>`
            
        }

        function flip(flipCard, newNumber) {
            const topHalf = flipCard.querySelector(".top")
            const startNumber = parseInt(topHalf.textContent)
            if (newNumber === startNumber) return

            const bottomHalf = flipCard.querySelector(".bottom")
            const topFlip = document.createElement("div")
            topFlip.classList.add("top-flip")
            const bottomFlip = document.createElement("div")
            bottomFlip.classList.add("bottom-flip")

            bottomHalf.innerHTML = `<span>${startNumber > 9 ? startNumber : `0${startNumber}`}</span>`
            topFlip.innerHTML = `<span>${startNumber > 9 ? startNumber : `0${startNumber}`}</span>`
            bottomFlip.innerHTML = `<span>${newNumber > 9 ? newNumber : `0${newNumber}`}</span>`

            topFlip.addEventListener("animationstart", e => {
                topHalf.innerHTML = `<span>${newNumber > 9 ? newNumber : `0${newNumber}`}</span>`
            })
            topFlip.addEventListener("animationend", e => {
                topFlip.remove()
            })
            bottomFlip.addEventListener("animationend", e => {
                bottomHalf.innerHTML = `<span>${newNumber > 9 ? newNumber : `0${newNumber}`}</span>`
                bottomFlip.remove()
            })
            flipCard.append(topFlip, bottomFlip)
        }
    }
}

export default ModuleCountDownFlip;